import { Box } from "@mui/material";

function AppBarContainer(props) {
  const { rightElement, centerElement, leftElement } = props;
  return (
    <Box
      sx={{
        width: "100%",
        minHeight: 56,
        px: "24px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
        }}
      >
        {rightElement}
      </Box>
      {centerElement && (
        <Box
          sx={{
            flex: 3,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {centerElement}
        </Box>
      )}
      <Box
        sx={{
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
        }}
      >
        {leftElement}
      </Box>
    </Box>
  );
}

export default AppBarContainer;
